import { createContext, useContext, useEffect, ReactNode } from 'react';
import { useMontessoriMode } from '@/hooks/useMontessoriMode';

type ThemeMode = 'default' | 'montessori';

interface ThemeValue {
  mode: ThemeMode;
  isMontessori: boolean;
  loading: boolean;
}

const ThemeContext = createContext<ThemeValue>({
  mode: 'default',
  isMontessori: false,
  loading: true,
});

export function MontessoriThemeProvider({ children }: { children: ReactNode }) {
  const { enabled, loading } = useMontessoriMode();
  const isMontessori = enabled;

  useEffect(() => {
    const root = document.documentElement;
    if (isMontessori) {
      root.setAttribute('data-montessori', 'true');
    } else {
      root.removeAttribute('data-montessori');
    }
  }, [isMontessori]);

  return (
    <ThemeContext.Provider value={{ mode: isMontessori ? 'montessori' : 'default', isMontessori, loading }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useMontessoriTheme = () => useContext(ThemeContext);
